import React from 'react';
import { AUTH_ACCESS, SUPER_ADMIN_ACCESS, SUPER_ADMIN_AND_ADMIN_ACCESS } from './PermissionsRoutes';

const Forbidden = React.lazy(() => import('pages/common/Forbidden'))
const NotFound = React.lazy(() => import('pages/common/404'))
const NoticeBoard = React.lazy(() => import('pages/board/NoticeBoard'))
const NoticeBoardWrite = React.lazy(() => import('pages/board/NoticeBoardWrite'))
const NoticeBoardDetail = React.lazy(() => import('pages/board/NoticeBoardDetail'))
const NoticeBoardModify = React.lazy(() => import('pages/board/NoticeBoardModify'))
const FileBoard = React.lazy(() => import('pages/board/FileBoard'))
const FileBoardWrite = React.lazy(() => import('pages/board/FileBoardWrite'))
const FileBoardDetail = React.lazy(() => import('pages/board/FileBoardDetail'))
const FileBoardModify = React.lazy(() => import('pages/board/FileBoardModify'))

const PF = '/board'
const RoutesBoard = [
    { path: `${PF}`, exact: true, name: '게시물 관리' },
    { path: `${PF}/notice`, exact: true, name: '공지 게시', element: <NoticeBoard />, ...SUPER_ADMIN_AND_ADMIN_ACCESS },
    { path: `${PF}/notice/write`, exact: true, name: '작성', element: <NoticeBoardWrite />, ...SUPER_ADMIN_ACCESS },
    { path: `${PF}/notice/detail/:no`, exact: true, name: '상세', element: <NoticeBoardDetail />, ...AUTH_ACCESS },
    { path: `${PF}/notice/modify/:no`, exact: true, name: '수정', element: <NoticeBoardModify />, ...SUPER_ADMIN_ACCESS },
    { path: `${PF}/file`, exact: true, name: '양식 게시', element: <FileBoard />, ...SUPER_ADMIN_AND_ADMIN_ACCESS },
    { path: `${PF}/file/write`, exact: true, name: '작성', element: <FileBoardWrite />, ...SUPER_ADMIN_ACCESS },
    { path: `${PF}/file/detail/:no`, exact: true, name: '상세', element: <FileBoardDetail />, ...AUTH_ACCESS },
    { path: `${PF}/file/modify/:no`, exact: true, name: '수정', element: <FileBoardModify />, ...SUPER_ADMIN_ACCESS },
]

export default RoutesBoard;
